import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { axiosCacheInstance } from "../../../axiosSetup";
import { AxiosError } from "axios";
import { RootState } from "../../features/template/store";

export const getUserProfile = createAsyncThunk(
  "userDetails/getUserProfile",
  async () => {
    try {
      const response = await axiosInstance.post(
        "api/user-management/v1/users/getLoginUserDetails"
      );
  return {
        status: response.status,
        data: response.data,
      };
     } catch (e) {
      const error = e as AxiosError;

      return {
        status: error.status,
        data: error.response?.data,
      };
    }
  }
);

export const getLocationsByCountry = createAsyncThunk(
  "userDetails/getLocationsByCountry",
  async ({country,locationAccess}:{country:string,locationAccess:any}) => {
   try {
     const params={
      country: country,
      portCodeList: locationAccess
     }
     const response = await axiosInstance.post(`/api/master/v1/mstPort/getPortListByCodeList`,params);
     return response.data;
   } catch (error) {
    return [];
   }
  }
);

export const getUserGridsDefinition = createAsyncThunk(
  "userDetails/getUserGridsDefinition",
  async (partnerCountry: any, {getState}:any) => {
    const state:RootState =getState()
    try {
      const response = await axiosInstance.get(
        `/api/user-management/v1/usergrid/masterGrids?linerId=${state.navbarTop.linerId}&country=${partnerCountry}`
      );

      return response.data.list;
    } catch (error) {
      return [];
    }
  }
);

export const getRbacDetails = createAsyncThunk(
  "userDetails/getRbacDetails",
  async () => {
    try {
      const response = await axiosInstance.get(
        "/api/user-management/v1/usergrid/fetchRbacGroups"
      );
      return { response };
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getAppConfig = createAsyncThunk(
  "userDetails/getAppConfig",
  async (key: any) => {
    try {
      const response = await axiosInstance.get(
        `/api/edo-rest-v2/v2/common/getAppValue?key=${key}`
      );
      return { response };
    } catch (e) {
      const error = e as AxiosError;

      return {};
    }
  }
);

export const getLinerConfig = createAsyncThunk(
  "userDetails/getLinerConfig",
  async ({country, linerId}: {country:String, linerId:number}) => {
    try {
      const response = await axiosCacheInstance.get(
        `api/edo-rest-v2/v2/common/getCountryLinerConfig?linerId=${linerId}&Country=${country}`,
      );
      return response.data

    } catch (e) {
      const error = e as AxiosError;
      console.error("Error fetching liner config: ",error)

      return {};
    }
  }
);
